import React from 'react';
import './inputs.scss';

export const StyledInput = ({ className, ...props }) => {
  return <input {...props} className={`caazam-input ${className}`} aria-label={`${props.name} input`}/>;
};
